import { LabeledTextInput } from "adviesbox-shared";
import { connect, FormikContextType } from "formik";
import React, { ReactElement } from "react";
import LabeledHdnKeuzelijst from "../../shared/components/hdn-keuzelijst/LabeledHdnKeuzelijst";
import { getPersonaliaTextResources } from "../infra/personalia-resources";
import { PersonaliaState } from "../infra/personalia-schema";

const Aanvrager1 = ({
  formik: {
    setFieldValue,
    values: { aanvrager1 }
  }
}: {
  formik: FormikContextType<PersonaliaState>;
}): ReactElement => (
  <div>
    <LabeledTextInput verplicht={true} caption="Achternaam" name="aanvrager1.achternaam" />
    <LabeledTextInput caption="Voorletters" name="aanvrager1.voorletters" />
    <LabeledTextInput caption="Tussenvoegsel" name="aanvrager1.tussenvoegselAchternaam" />
    <LabeledHdnKeuzelijst
      caption="Titel"
      name="aanvrager1.titel"
      emptyValue="Selecteer een optie"
      berichtSoortType="AX"
      keuzelijst="VoortitelType"
    />
    <LabeledTextInput caption="Roepnaam" name="aanvrager1.roepnaam" />
    <LabeledTextInput
      autoComplete="new-password"
      caption="Voornamen"
      name="aanvrager1.voornamen"
      tooltip={getPersonaliaTextResources("tooltipVoornamen")}
    />
    <LabeledTextInput
      autoComplete="new-password"
      caption="Geboortenaam"
      name="aanvrager1.geboortenaam"
      tooltip={getPersonaliaTextResources("tooltipGeboortenaam")}
    />
    <LabeledTextInput caption="Tussenvoegsel geboortenaam" name="aanvrager1.tussenvoegselGeboortenaam" />
  </div>
);

export default connect<{}, PersonaliaState>(Aanvrager1);
